import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import router from "@/router";
import { isApostleType, isUserType } from '@/tools/utils';
import { pageStyle, resetSliderWidth, sliderWidth } from "@/theme/sliderStyle";
import LoginRegisterBox from '@/components/Account/LoginRegisterBox.vue'; // functions

export default {
  __name: 'LoginPage',

  setup(__props) {
    const getUser = () => {
      request('user/get_user_info/', {}, 'GET').then(response => {
        // console.log(JSON.stringify(response.data))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.commit('update_user', response.data);
        const user_type = response.data.user_type;

        if (isUserType(user_type)) {
          store.dispatch('get_roles');
        } else if (isApostleType(user_type)) {
          store.commit('update_world_outlook', response.data.apostle_wo);
        }

        ElMessage.success({
          message: '链接雾海成功',
          duration: 1500
        });
        resetSliderWidth();
        router.replace('/account');
      });
    }; // lifecycle


    onMounted(() => {
      sliderWidth.value = 0;

      if (store.state.headers) {
        getUser();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createVNode(LoginRegisterBox, {
        onGetUser: getUser
      })], 4);
    };
  }

};